// $(document).ready(function () {
//    const $menuToggle = $('#menu-toggle');
//    const $menuDrawer = $('#menu-drawer');

//   $menuToggle.on('click', function () {
//     const expanded = $(this).attr('aria-expanded') === 'true';
//     $(this).attr('aria-expanded', !expanded);
//     $menuDrawer.toggleClass('hide_menu');
//   });
  
  
//   $('#menu-toggle').on('click', function () {
//     const isExpanded = $(this).attr('aria-expanded') === 'true';

//     if (isExpanded) {
//       $('body').addClass('overflow-hidden-tablet');
//     } else {
//       $('body').removeClass('overflow-hidden-tablet');
//     }
//   });
  
//   $(".custom_mobile_header .dropdown-toggle").on("click", function (e) {
//     e.preventDefault();

//     const $clickedToggle = $(this);
//     console.log($clickedToggle.parent, "$clickedToggle");
//     const $clickedMenu = $clickedToggle.parent().siblings(".dropdown-content");

//     $(".custom_mobile_header .dropdown-toggle").each(function () {
//       const $toggle = $(this);
//       const $content = $toggle.parent().siblings(".dropdown-content");

//       if ($toggle.is($clickedToggle)) return;
//       if ( $clickedMenu.has($content).length || $content.has($clickedMenu).length)
//         return;

//       $toggle.removeClass("menu_visible");
//       $content.slideUp(250);
//     });

//     $clickedToggle.toggleClass("menu_visible");
//     $clickedMenu.slideToggle(250);
//   });
// });



$(document).ready(function () {
  const $menuToggle = $('#menu-toggle');
  const $menuDrawer = $('#menu-drawer');

  $menuToggle.on('click', function (e) {
    e.stopPropagation(); // Prevent click from bubbling to body
    const expanded = $(this).attr('aria-expanded') === 'true';
    $(this).attr('aria-expanded', !expanded);
    $menuDrawer.toggleClass('hide_menu');

    if (!expanded) {
      $('body').addClass('overflow-hidden-tablet');
    } else {
      $('body').removeClass('overflow-hidden-tablet');
    }
  });

  // Close drawer on body click if open
  // $('body').on('click', function (e) {
  //   if ( !$(e.target).closest('#menu-drawer').length && !$(e.target).is('#menu-toggle') && $menuToggle.attr('aria-expanded') === 'true') {
  //     $menuDrawer.addClass('hide_menu');
  //     $menuToggle.attr('aria-expanded', 'false');
  //     $('body').removeClass('overflow-hidden-tablet');
  //   }
  // });
  
  // $('nav#menu-drawer').on('click', function (e) {
  //   $menuDrawer.addClass('hide_menu');
  //   $menuToggle.attr('aria-expanded', 'false');
  //   // $('body').removeClass('overflow-hidden-tablet');
  // });

  $(".custom_mobile_header .dropdown-toggle").on("click", function (e) {
    e.preventDefault();
    e.stopPropagation(); // Prevent body click from triggering

    const $clickedToggle = $(this);
    const $clickedMenu = $clickedToggle.parent().siblings(".dropdown-content");

    $(".custom_mobile_header .dropdown-toggle").each(function () {
      const $toggle = $(this);
      const $content = $toggle.parent().siblings(".dropdown-content");

      if ($toggle.is($clickedToggle)) return;
      if ($clickedMenu.has($content).length || $content.has($clickedMenu).length) return;

      $toggle.removeClass("menu_visible");
      $content.slideUp(250);
    });

    $clickedToggle.toggleClass("menu_visible");
    $clickedMenu.slideToggle(250);
  });
});




// $(document).ready(function () {
//   const $menuToggle = $('#menu-toggle');
//   const $menuDrawer = $('#menu-drawer');
//   const $menuOverlay = $('#menu-overlay');

//   // Toggle drawer and overlay
//   $menuToggle.on('click', function (e) {
//     e.stopPropagation();
//     const expanded = $(this).attr('aria-expanded') === 'true';
//     $(this).attr('aria-expanded', !expanded);

//     $menuDrawer.toggleClass('hide_menu');
//     $menuOverlay.toggleClass('hide_menu');

//     if (!expanded) {
//       $('body').addClass('overflow-hidden-tablet');
//     } else {
//       $('body').removeClass('overflow-hidden-tablet');
//     }
//   });

//   // Click on overlay = close drawer and overlay
//   $menuOverlay.on('click', function () {
//     $menuDrawer.addClass('hide_menu');
//     $menuOverlay.addClass('hide_menu');
//     $menuToggle.attr('aria-expanded', 'false');
//     $('body').removeClass('overflow-hidden-tablet');
//   });

//   // Close when clicking outside menu and toggle
//   $('body').on('click', function (e) {
//     if (
//       !$(e.target).closest('#menu-drawer').length &&
//       !$(e.target).is('#menu-toggle') &&
//       $menuToggle.attr('aria-expanded') === 'true'
//     ) {
//       $menuDrawer.addClass('hide_menu');
//       $menuOverlay.addClass('hide_menu');
//       $menuToggle.attr('aria-expanded', 'false');
//       $('body').removeClass('overflow-hidden-tablet');
//     }
//   });

//   // Prevent menu clicks from bubbling to body
//   $('#menu-drawer').on('click', function (e) {
//     e.stopPropagation();
//   });

//   // Dropdown toggle logic
//   $(".custom_mobile_header .dropdown-toggle").on("click", function (e) {
//     e.preventDefault();
//     e.stopPropagation();

//     const $clickedToggle = $(this);
//     const $clickedMenu = $clickedToggle.parent().siblings(".dropdown-content");

//     $(".custom_mobile_header .dropdown-toggle").each(function () {
//       const $toggle = $(this);
//       const $content = $toggle.parent().siblings(".dropdown-content");

//       if ($toggle.is($clickedToggle)) return;
//       if ($clickedMenu.has($content).length || $content.has($clickedMenu).length) return;

//       $toggle.removeClass("menu_visible");
//       $content.slideUp(250);
//     });

//     $clickedToggle.toggleClass("menu_visible");
//     $clickedMenu.slideToggle(250);
//   });
// });
